import axios from "axios";
import { nordNxtApiEndpoint } from "../../config/config";

async function getCryptoPrices() {
  const { data } = await axios.get(`${nordNxtApiEndpoint}/get-asset-prices`);
  return data;
}

export default getCryptoPrices;
